var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
var React = require( 'react' );
var createReactClass = require('create-react-class');
var BodyPartList = require('./bodyPartList.jsx');
var SymptomList = require('./symptomList.jsx');
var DiseaseList = require('./diseaseList.jsx');
var QolList = require('./qolList.jsx');

var MainNav = createReactClass({
	componentDidMount: function(){
		$('.toggles select').val(this.props.activeEducationToggle);
	},

	toggle: function(e){
		this.props.toggleEducation(e.target.options[e.target.selectedIndex].value);
	},

	toggleSymptoms: function(){
		this.props.toggleEducation('SYMPTOMS');
	},

	toggleDiseases: function(){
		this.props.toggleEducation('DISEASES');
	},

	toggleBodyParts: function(){
		this.props.toggleEducation('BODYPARTS');
	},

	toggleQOLs: function(){
		this.props.toggleEducation('QOLS');
	},

	toggleNext: function(){
		var $next = $('.toggles .toggle.is-active').next('.toggle');
		if($next.length === 1){
			$next[0].click && $next[0].click();
		}else{
			this.toggleSymptoms();
		}
	},

	togglePrevious: function(){
		var $previous = $('.toggles .toggle.is-active').prev('.toggle');
		if($previous.length === 1){
			$previous[0].click && $previous[0].click();
		}else{
			this.toggleQOLs();
		}
	},

	render: function(){
		const { isAdmin } = this.props;
		var isSymptomsActive = this.props.activeEducationToggle === 'SYMPTOMS';
		var isDiseasesActive = this.props.activeEducationToggle === 'DISEASES';
		var isBodyPartsActive = this.props.activeEducationToggle === 'BODYPARTS';
		var isQOLsActive = this.props.activeEducationToggle === 'QOLS';

		return (
			<div id="list-container">
				<div className="toggles clearfix">
					<div className="show-for-small-only">
						<select onChange={this.toggle}>
							<option value="SYMPTOMS">Symptoms</option>
							<option value="DISEASES">Diseases</option>
							<option value="BODYPARTS">System</option>
							<option value="QOLS">MyQ</option>
						</select>
						<span className="ion-ios-arrow-down"></span>
					</div>
					<a className={'symptoms-toggle toggle' + (isSymptomsActive ? ' is-active' : '')} onClick={this.toggleSymptoms}>Symptoms</a>
					<a className={'diseases-toggle toggle' + (isDiseasesActive ? ' is-active' : '')} onClick={this.toggleDiseases}>Diseases</a>
					<a className={'bodyparts-toggle toggle' + (isBodyPartsActive ? ' is-active' : '')} onClick={this.toggleBodyParts}>System</a>
					<a className={'qols-toggle toggle' + (isQOLsActive ? ' is-active' : '')} onClick={this.toggleQOLs}>MyQ</a>
				</div>
				<div className="orbit">
					<div className="orbit-previous" onClick={this.togglePrevious}><span className="ion-ios-arrow-back"></span></div>
					<div className="orbit-next" onClick={this.toggleNext}><span className="ion-ios-arrow-forward"></span></div>
					<ul className="orbit-container">
						<SymptomList
						  id='slide-0'
						  isActive={isSymptomsActive}
						  symptoms={this.props.symptoms}
						  isAdmin={isAdmin}
						  clickTracking={this.props.clickTracking} />
						<DiseaseList
						  id='slide-1'
						  isActive={isDiseasesActive}
						  diseases={this.props.diseases}
						  isAdmin={isAdmin}
						  clickTracking={this.props.clickTrackingOfAGA} />
						<BodyPartList
						  id='slide-2'
						  isActive={isBodyPartsActive}
						  bodyParts={this.props.bodyParts}
						  isAdmin={isAdmin}
						  clickTracking={this.props.clickTracking} />
						<QolList
						  id='slide-3'
						  isActive={isQOLsActive}
						  qols={this.props.qols}
						  isAdmin={isAdmin}
						  clickTracking={this.props.clickTracking} />
					</ul>
				</div>
			</div>
		);
	}
});

module.exports = MainNav;



// WEBPACK FOOTER //
// ./src/common/routes/education/components/layout/mainNav.jsx